import { emptyFn, randomTimerUpdateCache } from './utils/utils'

import store from './store'
// import { CACHE_INFO_KEYS } from './utils/cache'

let updateCacheInfoTimer

function initCacheInfoUpdateSysDictConfig (isInit) {
  return new Promise((resolve, reject) => {
    store.dispatch('initCacheInfo')
      .then(() => {
        if (isInit) {
          store.dispatch('getSysConfigDict')
        }
        updateCacheInfoTimer = setTimeout(() => {
          initCacheInfoUpdateSysDictConfig()
        }, randomTimerUpdateCache())
        resolve()
      })
      .catch((err) => {
        reject(err)
        return emptyFn
      })
  })
}

initCacheInfoUpdateSysDictConfig(true)

export default function () {
  clearTimeout(updateCacheInfoTimer)
}



// WEBPACK FOOTER //
// ./src/system.js